import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DELETE_MESSAGE } from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';

const ApproveOrRejectConfirm = ({ deleteApiUrl, open, onClose }) => {
    const [reasontext,setReasonText]=useState("")
    const token = localStorage.getItem("Token");
    const deleteRequestParam = JSON.parse(localStorage.getItem("StatusRequestParam"));

  const handleSubmit = () => {
    //put your validation logic here
   
    const data={
        id: deleteRequestParam.id,
        status: deleteRequestParam.status,
        reason: deleteRequestParam.showmodalid==3 ? "" : reasontext
    }

    axios
    .post(`${deleteApiUrl}`, data, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
    })
    .then((response) => {
      console.log("Receving Types", response.data.ResponseData);
      window.location.reload();
      // setRectype(response.data.ResponseData);
    })
    .catch((error) => {
      console.log(error);
    });
    onClose();
  };


  return (
    <>
    {deleteRequestParam?.showmodalid==3 ? (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Confirmation</DialogTitle>
      <DialogContent>
        Are you sure you want to Approve this record?
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button style={{
          backgroundColor: '#FF9F43',
          color: 'white'
        }} onClick={handleSubmit} variant="contained">
          Approve
        </Button>
      </DialogActions>
    </Dialog>):  
    
    <Dialog open={open}>
      <DialogTitle textAlign="center">Confirmation</DialogTitle>
      <DialogContent>
        Are you sure you want to Reject this record?
        <div className="mt-2">
        <label className="mt-2">Reason</label>
        <textarea
         type="text"
         className="form-control"
         value={reasontext}
         onChange={(e)=>setReasonText(e?.target.value)}
         row={2}
         />
         </div>
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button style={{
          backgroundColor: '#FF9F43',
          color: 'white'
        }} onClick={handleSubmit} variant="contained">
          Reject
        </Button>
      </DialogActions>
    </Dialog>}
    </>
  );

 
  //   <>
  //       // <div className="modal fade" id="DeleteConfirmationModal">
  //       //   <div className="modal-dialog modal-sm modal-dialog-centered">
  //       //     <div className="modal-content">
  //       //       <div className="modal-header">
  //       //         <h5 className="modal-title">Confirmation</h5>
  //       //         <button
  //       //           type="button"
  //       //           className="close"
  //       //           data-bs-dismiss="modal"
  //       //           aria-label="Close"
  //       //           onClick={() => setShowModal(false)}
  //       //         >
  //       //           <span aria-hidden="true">×</span>
  //       //         </button>
  //       //       </div>
  //       //       <div className="modal-body">
  //       //         <div className="row">
  //       //           <div className="col-lg-12">
  //       //             <h6>Are you sure you want to delete this record?</h6>
  //       //           </div>
  //       //         </div>
  //       //       </div>
  //       //       <div className="modal-footer justify-content-center">
  //       //         <Link
  //       //           to="#"
  //       //           className="btn btn-primary btn-md me-1"
  //       //           data-bs-dismiss="modal"
  //       //           onClick={handleDeletePopup}
  //       //         >
  //       //           Delete
  //       //         </Link>
  //       //         <Link
  //       //           to="#"
  //       //           className="btn btn-dark btn-md me-1"
  //       //           data-bs-dismiss="modal"
  //       //           onClick={() => setShowModal(false)} // Close the modal
  //       //         >
  //       //           Cancel
  //       //         </Link>
  //       //       </div>
  //       //     </div>
  //       //   </div>
  //       // </div>
  //   </>
  // );

};

export default ApproveOrRejectConfirm;
